export default {
    data () {
        return {
            user: {
                email: '',
                state: ''
            },
            form: {},
            busy: false,
            success: null,
        };
    },

    created () {
        this.form = new Form2(this.user)
            .setAction('/mailing-list/store');
    },

    methods: {
        submit () {
            if (this.busy) {
                return;
            }

            this.busy = true;
            this.success = null;

            this.form.post()
                .then(data => {
                    if (data.results && data.results.saved) {
                        this.success = data.message;

                        setTimeout(() => {
                            this.success = null;
                        }, 3000);

                        this.user.email = '';
                        this.user.state = '';
                    }
                })
                .catch(error => showResponse('An unexpected error has occurred.', 'error'))
                .finally(() => this.busy = false);
        }
    }
};